import { CartUpdateParams } from "./api/cart";
import { GlobalInterceptor } from "./api/fetch/interceptors";
import { FetchBody } from "./api/fetch/fetch.types";
import * as api from "./api";

const dispatchCartEvent = (eventName: string, detail: any) => {
  document.dispatchEvent(new CustomEvent(eventName, { detail }));
};

const cartGetInterceptor = async (body: FetchBody, res: Response) => {
  const cart = await res.json();
  dispatchCartEvent('cart:get', { cart });
};

const cartAddInterceptor = async (body: FetchBody, res: Response) => {
  const items = await res.json();
  dispatchCartEvent('cart:add', { items });
  api.cart.get(true).then(cart => dispatchCartEvent('cart:all', { cart }));
};

const cartAddFormInterceptor = async (body: FetchBody, res: Response): Promise<void> => {
  let cart = await api.cart.get(true);
  const items = cart.items;
  dispatchCartEvent('cart:addform', { items });
  dispatchCartEvent('cart:add', { items });
  dispatchCartEvent('cart:all', { cart });
};

const cartUdpateInterceptor = async (body: FetchBody, res: Response) => {
  const cart = await res.json();
  dispatchCartEvent('cart:update', { cart });
  dispatchCartEvent('cart:edit', { cart });
  if (typeof body == 'object' && (body as CartUpdateParams).attributes) {
    dispatchCartEvent('cart:attributes', { cart });
  }
  dispatchCartEvent('cart:all', { cart });
}

const cartChangeInterceptor = async (body: FetchBody, res: Response) => {
  const cart = await res.json();
  dispatchCartEvent('cart:change', { cart });
  dispatchCartEvent('cart:edit', { cart });
  dispatchCartEvent('cart:all', { cart });
}

export function initCartEvents(interceptor: GlobalInterceptor) {
  interceptor.interceptAfter("GET:/cart.js", cartGetInterceptor);
  interceptor.interceptAfter("GET:/cart.json", cartGetInterceptor);
  interceptor.interceptAfter("POST:/cart/add.js", cartAddInterceptor);
  interceptor.interceptAfter("POST:/cart/add.json", cartAddInterceptor);
  interceptor.interceptAfter("POST:/cart/add", cartAddFormInterceptor);
  interceptor.interceptAfter("POST:/cart/update.js", cartUdpateInterceptor);
  interceptor.interceptAfter("POST:/cart/update.json", cartUdpateInterceptor);
  interceptor.interceptAfter("POST:/cart/change.js", cartChangeInterceptor);
  interceptor.interceptAfter("POST:/cart/change.json", cartChangeInterceptor);
  interceptor.interceptAfter("POST:/cart/change", cartChangeInterceptor);
}
